import { useState } from 'react';
import { apiNode } from '../../../../services/api';
import { ButtonsContainer, Container, Content } from './styles';

import { SyncOutlined } from '@ant-design/icons';
import { AiOutlineClose, AiOutlineCheck } from 'react-icons/ai';

interface RequestProps {
  id: number;
  user: {
    name: string;
    foto: string;
  };
}

interface CardProps {
  request: RequestProps;
  openSuccessModal: (request: RequestProps) => void;
  updateRequestsList: (id: number) => void;
}

export const Card: React.FC<CardProps> = ({
  request,
  openSuccessModal,
  updateRequestsList,
}: CardProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const [isAcceptButtonLoading, setIsAcceptButtonLoading] = useState(false);
  const [isDeclineButtonLoading, setIsDeclineButtonLoading] = useState(false);

  const handleAcceptPlayerRequest = async () => {
    try {
      setIsLoading(true);
      setIsAcceptButtonLoading(true);

      await apiNode.put(`/ligas/aceitar/pedido/${request.id}`);

      updateRequestsList(request.id);
      openSuccessModal(request);
      setIsLoading(false);
      setIsAcceptButtonLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      setIsAcceptButtonLoading(false);
    }
  };

  const handleDeclinePlayerRequest = async () => {
    try {
      setIsLoading(true);
      setIsDeclineButtonLoading(true);

      await apiNode.put(`/ligas/recusar/pedido/${request.id}`);

      updateRequestsList(request.id);
      setIsLoading(false);
      setIsDeclineButtonLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      setIsDeclineButtonLoading(false);
    }
  };

  return (
    <Container>
      <Content>
        <span>
          <img
            src={
              request.user.foto
                ? request.user.foto
                : 'https://www.pinclipart.com/picdir/middle/157-1578186_user-profile-default-image-png-clipart.png'
            }
            alt={`Foto de ${request.user.name}`}
          />
        </span>

        <div>
          <span>
            <h1>{request.user.name}</h1>
          </span>
        </div>

        <ButtonsContainer>
          <button
            type="button"
            {...(!isLoading && { onClick: handleAcceptPlayerRequest })}
          >
            {isAcceptButtonLoading ? <SyncOutlined spin /> : <AiOutlineCheck />}
          </button>
          <button
            type="button"
            {...(!isLoading && { onClick: handleDeclinePlayerRequest })}
          >
            {isDeclineButtonLoading ? (
              <SyncOutlined spin color="red" />
            ) : (
              <AiOutlineClose />
            )}
          </button>
        </ButtonsContainer>
      </Content>
    </Container>
  );
};
